import * as React from "react";
import { Routes, Route, useLocation } from "react-router-dom";

import { TooltipProvider } from "@/components/ui/tooltip";

import { UserProvider } from "@/provider/user";
import { UIProvider } from "@/provider/ui";
import { Wrapper } from "@/components/wrapper";

import LoginPage from "@/components/login-page";
import LandingPage from "@/components/landing-page";
import NewProject from "@/components/new-project-milestone";
import ImportProject from "@/components/import-project"; // Added import
import AppDetails from "@/components/app-details";
import Milestones from "./components/project-milestones";
import ProfilePage from "@/components/profile-page";
import { ChatPage } from "@/components/ChatPage";

export default function App() {
  const location = useLocation(); // If App is already inside the Router

  React.useEffect(() => {
    console.log(
      `App Route changed to: ${location.pathname}${location.search}${location.hash}`,
    );
  }, [location]);

  return (
    <UIProvider>
      <TooltipProvider>
        <UserProvider>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route
              path="/"
              element={
                <Wrapper>
                  <LandingPage />
                </Wrapper>
              }
            />
            <Route
              path="/new"
              element={
                <Wrapper>
                  <NewProject />
                </Wrapper>
              }
            />
            <Route
              path="/import"
              element={
                <Wrapper>
                  <ImportProject />
                </Wrapper>
              }
            />
            <Route
              path="/projects/:projectId"
              element={
                <Wrapper>
                  <Milestones />
                </Wrapper>
              }
            />
            <Route
              path="/projects/:projectId/milestones"
              element={
                <Wrapper>
                  <Milestones />
                </Wrapper>
              }
            />
            <Route
              path="/projects/:projectId/:appName"
              element={
                <Wrapper>
                  <AppDetails />
                </Wrapper>
              }
            />
            <Route
              path="/profile"
              element={
                <Wrapper>
                  <ProfilePage />
                </Wrapper>
              }
            />
            <Route
              path="/chat/:chatId?"
              element={
                <Wrapper>
                  <ChatPage />
                </Wrapper>
              }
            />
          </Routes>
        </UserProvider>
      </TooltipProvider>
    </UIProvider>
  );
}
